import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core'

import { GalleryItem, LayoutGallery } from 'app/core/cms/generated/api-types'
import { ApplyPipe } from 'app/shared/apply/apply.pipe'
import { CmsIdDirective } from 'app/shared/cms-id.directive'
import { PictureComponent } from 'app/shared/picture/picture.component'
import { explicitComputed } from 'app/utils/signal-utils'

import { CmsBlock } from '../../cms-block'
import { ContainerInfo, divideContainerSize } from '../../container-info'
import { LayoutContainer } from '../../sections/layout-container'

@Component({
  selector: 'pai-layout-gallery',
  templateUrl: './layout-gallery.component.html',
  styleUrls: ['./layout-gallery.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PictureComponent, CmsIdDirective, ApplyPipe],
  providers: [{ provide: CmsBlock, useExisting: LayoutGalleryComponent }],
  host: {
    '[style.--col-count]': 'colCount()',
  },
})
export class LayoutGalleryComponent extends CmsBlock<LayoutGallery> {
  readonly __typename = 'LayoutGallery'

  private readonly layoutContainer = inject(LayoutContainer)
  protected readonly colCount = computed(() => {
    return parseInt(this.data().galleryItemsColumnCount?.replace('_', '') ?? '2')
  })

  readonly containerInfo = explicitComputed(
    [inject(LayoutContainer, { skipSelf: true }).containerInfo, this.colCount],
    (parent, colCount): ContainerInfo => {
      return {
        maxWidthAtMd: `50vw`, // always 2 cols at md
        maxWidthAtLg: divideContainerSize(parent.maxWidthAtLg, colCount),
        maxWidthAtXl: divideContainerSize(parent.maxWidthAtXl, colCount),
      }
    },
  )
  protected readonly calcRowCount = (item: GalleryItem): number => {
    const X = 10

    const width = item.image?.width ?? 1
    const height = item.image?.height ?? 1

    // add one more col if caption
    // add one more col for padding
    return Math.round((X / width) * height) + (item.caption ? 1 : 0) + 1
  }
}
